export const COMPONENT_NAME = "kyc-documents";

export const SELFIE_TOOLTIP_TEXT = `Пожалуйста, сделайте селфи, ориентируясь на пример.
На фотографии должно быть чётко видно ваше лицо целиком — лоб, глаза, нос и подбородок не должны быть обрезаны или закрыты.
В одной руке держите документ, выбранный на предыдущем шаге (паспорт, ID ), так чтобы было видно фото и основные данные.
В другой руке держите лист бумаги, на котором от руки написаны текущая дата, текст LLC "MEX" и ваша подпись.
Лицо, документ и лист с текстом должны быть одновременно в одном кадре.
Фото должно быть сделано при хорошем освещении, без теней и затемнений.
Избегайте бликов на документе — данные должны быть читаемы.
Не используйте фильтры, маски, ретушь или портретный режим камеры.
Фотография должна быть резкой, без смаза и следов редактирования.
Скриншоты, коллажи и фотографии с экрана не принимаются.`;